import { IPublicClientApplication } from '@azure/msal-browser';

/**
 * Helper to acquire an access token for API requests using MSAL.
 * Attempts silent acquisition, falls back to popup if needed.
 * Throws if no authenticated account is found.
 */
export async function getAccessTokenHelper(msalInstance: IPublicClientApplication, forceRefresh = false): Promise<string> {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    throw new Error('No authenticated account found');
  }
  const request = {
    scopes: [`${process.env.REACT_APP_CLIENT_ID || '262b88ff-8a8d-49fc-8485-017906bd3c29'}/user_impersonation`],
    account: accounts[0],
    forceRefresh,
  };
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch {
    const response = await msalInstance.acquireTokenPopup(request);
    return response.accessToken;
  }
}
